<script setup>
import { computed } from 'vue';
import { Line } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler,
} from 'chart.js';

const props = defineProps({
  collection: {
    type: Object,
    default: () => ({}),
  },
  chartOptions: {
    type: Object,
    default: () => ({}),
  },
});

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Filler
);

const fontFamily =
  'Inter,-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif';

const defaultChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: 'index',
    intersect: false,
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      backgroundColor: '#1c2433',
      titleColor: '#ffffff',
      bodyColor: '#e6eaf0',
      padding: 12,
      cornerRadius: 12,
      displayColors: false,
    },
  },
  animation: {
    duration: 0,
  },
  scales: {
    x: {
      ticks: {
        fontFamily,
        maxRotation: 0,
        autoSkip: true,
        maxTicksLimit: 10,
      },
      grid: {
        display: false,
      },
      border: {
        display: false,
      },
    },
    y: {
      beginAtZero: true,
      ticks: {
        fontFamily,
        precision: 0,
      },
      grid: {
        color: 'rgba(148, 163, 184, 0.18)',
        drawBorder: false,
      },
      border: {
        display: false,
      },
    },
  },
};

const options = computed(() => ({
  ...defaultChartOptions,
  ...props.chartOptions,
  plugins: {
    ...defaultChartOptions.plugins,
    ...props.chartOptions.plugins,
    legend: {
      ...defaultChartOptions.plugins.legend,
      ...props.chartOptions.plugins?.legend,
    },
    tooltip: {
      ...defaultChartOptions.plugins.tooltip,
      ...props.chartOptions.plugins?.tooltip,
      callbacks: {
        ...(defaultChartOptions.plugins.tooltip.callbacks || {}),
        ...(props.chartOptions.plugins?.tooltip?.callbacks || {}),
      },
    },
  },
  scales: {
    x: {
      ...defaultChartOptions.scales.x,
      ...(props.chartOptions.scales?.x || {}),
    },
    y: {
      ...defaultChartOptions.scales.y,
      ...(props.chartOptions.scales?.y || {}),
    },
  },
}));
</script>

<template>
  <Line :data="collection" :options="options" />
</template>
